export default {
  "首页": "Home",
  "订单": "Orders",
  "新闻": "News",
  "个人中心": "Profile",
  "模拟账户": "Demo Account",
  "可用资产": "Available Assets",
  "入金": "Deposit",
  "出金": "Withdrawal",
  "账单详情": "Billing Details",
  "重置模拟账户": "Reset Demo Account",
  "钱包": "Wallet",
  "实名认证": "Identity Verification",
  "邀请好友": "Invite Friends",
  "修改密码": "Change Password",
  "投诉邮箱": "Complaint Email",
  "其它": "Others",
  "公告": "Announcements",
  "语言": "Language",
  "是否退出登录": "Log Out?",
  "复制": "Copy",
  "复制成功": "Copied Successfully",
  "发送验证码成功": "Verification Code Sent Successfully",
  "请输入密码": "Please Enter Password",
  "请再次输入密码": "Please Enter Password Again",
  "复制邀请链接": "Copy Invite Link",
  "上传身份": "Please Upload Front and Back of ID/Passport",
  "正面": "Front",
  "上传正面": "Upload Front of ID/Passport",
  "反面": "Back",
  "上传反面": "Upload Back of ID/Passport",
  "完善信息": "Please Complete Your Information",
  "输入姓名": "Please Enter Your Name",
  "身份证号": "ID/Passport Number",
  "输入身份证号": "Please Enter Your ID/Passport Number",
  "收款货币": "Receiving Currency",
  "银行名称": "Bank Name",
  "收款人账户": "Recipient Account",
  "货币": "Currency",
  "分店名称": "Branch Name",
  "绑定银行卡": "Link Bank Card",
  "银行地址": "Bank Address",
  "账号名称（假名）": "Account Name (Alias)",
  "绑定数字货币地址": "Link Crypto Address",
  "余额": "Balance",
  "联系客服": "Contact Support",
  "行情": "Market",
  "其他": "Others",
  "设置": "Settings",
  "收款人": "Recipient",
  "添加": "Add",
  "确认": "Confirm",
  "取消": "Cancel",
  "钱包地址": "Wallet Address",
  "请输入": "Please Enter",
  "退出登录": "Log Out",
  "充值数量": "Deposit Amount",
  "提交": "Submit",
  "银行卡": "Bank Card",
  "选择网络": "Select Network",
  "数字货币": "Cryptocurrency",
  "上传验证": "Upload Verification",
  "提币地址": "Withdrawal Address",
  "数量(USD)": "Amount (USD)",
  "备注": "Remarks",
  "手续费": "Fee",
  "预计到账数量": "Estimated Amount Received",
  "暂无数据": "No Data Available",
  "入金记录": "Deposit Records",
  "提币记录": "Withdrawal Records",
  "验证码": "Verification Code",
  "邀请码": "Invitation Code",
  "提示": "Tip",
  "请输入验证码": "Please Enter Verification Code",
  "姓名": "Name",
  "邮箱登录": "Email Login",
  "邮箱": "Email",
  "密码": "Password",
  "新用户": "New User",
  "立即加入": "Join Now",
  "忘记密码": "Forgot Password",
  "登录": "Log In",
  "无需开户,立即创建模拟账号进行交易!": "No Account Needed, Create a Demo Account to Start Trading Now!",
  "电话": "Phone",
  "再次输入密码": "Re-enter Password",
  "职业": "Occupation",
  "年收入": "Annual Income",
  "注册": "Sign Up",
  "邮箱注册": "Email Registration",
  "发送": "Send",
  "重置密码": "Reset Password",
  "是否重置": "Reset?",
  "已重置": "Reset Successful",
  "名称": "Name",
  "注册成功": "Registration Successful",
  "加载中": "Loading",
  "您还未登录，请先登录": "You Are Not Logged In, Please Log In First",
  "退出成功": "Logged Out Successfully",
  "市价": "Market Price",
  "挂单": "Pending Order",
  "倍数": "Multiplier",
  "止盈": "Take Profit",
  "止损": "Stop Loss",
  "买入数量": "Buy Quantity",
  "每手": "Per Lot",
  "预估手续费": "Estimated Fee",
  "预估保证金": "Estimated Margin",
  "买入": "Buy",
  "卖出": "Sell",
  "您的订单已确认": "Your Order Has Been Confirmed",
  "订单页面": "Order Page",
  "盈亏": "Profit and Loss",
  "当前保证金": "Current Margin",
  "订单详情": "Order Details",
  "保证金": "Margin",
  "平仓": "Close Position",
  "修改": "Modify",
  "手数": "Lots",
  "暂无数据": "No Data Available",
  "历史": "History",
  "价格": "Price",
  "请输入价格": "Please Enter Price",
  "手": "Lot",
  "搜索结果": "Search Results",
  "搜索产品": "Search Products",
  "持仓": "Positions",
  "语言": "Language",
  "审核中": "Under Review",
  "请上传证件照正/反面": "Please Upload Front and Back of ID",
  "上传成功": "Upload Successful",
  "上传失败": "Upload Failed",
  "提交成功": "Submission Successful",
  "删除": "Delete",
  "删除成功": "Deleted Successfully",
  "提币": "Withdraw",
  "缺少参数或传值错误": "Missing Parameters or Incorrect Input",
  "操作成功": "Operation Successful",
  "充值金额": "Deposit Amount",
  "类型": "Type",
  "状态": "Status",
  "时间": "Time",
  "单位": "Unit",
  "最高价": "Highest Price",
  "最低价": "Lowest Price",
  "开盘价": "Opening Price",
  "请注册或登录真实账号": "Please Register or Log in with a Real Account",
  "没有更多了": "No More Data",
  "提现金额": "Withdrawal Amount",
  "审核通过": "Review Approved",
  "审核不通过": "Review Denied",
  "重新提交": "Resubmit",
  "止盈价": "Take Profit Price",
  "止损价": "Stop Loss Price",
  "总盈亏": "Total Profit and Loss",
  "撤单": "Cancel Order",
  "请先进行实名认证": "Please Complete Identity Verification First",
  "产品列表": "Product List",
  "下单": "Place Order",
  "可用资金": "Available Funds",
  "欢迎登录": "Welcome",
  "可用": "Available",
  "冻结": "Frozen",
  "财务记录": "Financial Records",
  "交易对": "Trading Pair",
  "开仓时间": "Opening Time",
  "收益": "Profit",
  "操作": "Action",
  "下单价": "Order Price",
  "当前价": "Current Price",
  "订单号": "Order Number",
  "请选择": "Please select",
  "卖出(做空)止损价不能低于开仓价": "Sell (short) stop-loss price cannot be lower than the opening price",
  "卖出(做多)止盈价不能高于开仓价": "Sell (long) take-profit price cannot exceed the opening price",
  "买入(做多)止损价不能高于开仓价": "Buy (long) stop-loss price cannot exceed the opening price",
  "买入(做多)止盈价不能低于开仓价": "Buy (long) take-profit price cannot be lower than the opening price",
  "买入(做多)止盈价不能低于开仓价和现价": "Buy (long) take-profit price cannot be lower than the opening and current prices",
  "买入(做多)止损价不能高于开仓价和现价": "Buy (long) stop-loss price cannot exceed the opening and current prices",
  "卖出(做空)止损价不能低于开仓价和现价": "Sell (short) stop-loss price cannot be lower than the opening and current prices",
  "卖出(做多)止盈价不能高于开仓价和现价": "Sell (long) take-profit price cannot exceed the opening and current prices",

  "提现手续费": "Withdrawal handling fee",
  "提现退回": "Withdrawal refund",
  "系统加款": "System Plus",
  "系统减款": "System Reduction",

  "交易周期": "Transaction cycle",
  "秒": "Second",
  "交易额": "Transaction amount",
  "买涨": "Buy for a rise",
  "买跌": "Buy for a fall",
  "秒数": "Number of seconds",
  "交易类型": "Transaction type",
  "看涨": "Bullish",
  "看跌": "Bearish",
  "剩余时间": "Remaining time",
  "买入价": "Purchase price",
  "结算价": "Settlement price",
  "交易额": "Transaction amount",
  "下单时间": "Order placement time",
  "结算时间": "Settlement time",
  "该币种暂无交易": "There are currently no transactions for this currency",

  "总资产": "Total Assets",
  "币种": "Currency",
  "资产折合": "Asset Conversion",
  "冻结金额": "Frozen Amount",
  "可用金额": "Available Amount",
  "公司资产": "Company Assets",
  "请输入旧密码": "Please enter the old password",
  "请输入新密码": "Please enter the new password",
  "请再次输入新密码": "Please re-enter the new password",
  "白皮书": "White Paper",
  "注册证书": "Registration Certificate",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "The official reserves the right to the final interpretation of the above information",
  "上一页": "Previous Page",
  "下一页": "Next Page",
  "关闭": "Close",
  "闪电兑换": "Lightning Exchange",
  "全部": "All",
  "可用余额": "Available Balance",
  "到": "To",
  "请输入数量": "Please enter the quantity",
  "币种选择": "Currency Selection",
  "从": "From",
  "兑换": "Exchange",
  "兑换成功！": "Exchange Successful!",
  "支付": "Pay",
  "全部兑换成功": "All exchanges are successful",
  "获取": "Obtain",
  "数量": "Quantity",
  "拒绝原因": "Reject Reason",
  "交易密码": "Transaction Password",
  "设置交易密码": "Set Transaction Password",
  "重置交易密码": "Reset Transaction Password",
  "确定": "Confirm",
  "是否购买？": "Purchase?",
  "外汇": "Foreign Exchange",
  "期权": "Options",
  "(用户中心)": "(User Center)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Your transaction is being processed, please wait patiently for the transaction to be completed before performing other operations!",
  "继续下单": "Continue Order",
  "交易方向": "Trade Direction",
  "实现盈利": "Realize Profit",
  "最新价格": "Latest Price",
  "结算完成": "Settlement Completed",
  "下单余额不足": "Insufficient balance to place order",
  "输入交易额度": "Enter transaction amount",
  "选择交易周期": "Select trading period",
  "审核拒绝": "Review rejected",
  "请输入正确的数量!": "Please enter the correct quantity!",
  "上传身份": "Upload ID",
  "上传正面": "Upload front side",
  "上传反面": "Upload back side",
  "完善信息": "Complete information",
  "输入姓名": "Enter name",
  "输入身份证号": "Enter ID number",
  "身份证号": "ID number",
  "请上传证件照正/反面": "Please upload front/back of the ID",
  "最小提现金额10USDT": "Minimum withdrawal amount is 10 USDT",
  "证件号码": "ID Number",
  "输入证件号码": "Enter ID Number",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Please upload either your ID card, driver's license, or passport for identity verification!"


}
